import { AuthContext } from '@app/core/auth/authentication/context/auth-context';
import { useContext } from 'react';
import { useImpersonation } from './useImpersonationStore';
import { useIsImpersonationOn } from './useIsImpersonationOn';

/**
 * Short label for the browser tab title while impersonating (client name preferred).
 * Safe outside AuthProvider (e.g. login): returns null when not impersonating or unknown yet.
 */
export function useImpersonationHtmlTitlePrefix(): string | null {
  const isImpersonating = useIsImpersonationOn();
  const authContext = useContext(AuthContext);
  const { authAsUserId, impersonatedUser, recentUsers } = useImpersonation();

  if (!isImpersonating || !authAsUserId) {
    return null;
  }

  const auth = authContext?.auth;
  // Prefer the user matching the effective auth_as (tab override may differ from persisted).
  const storedUser =
    impersonatedUser?.id === authAsUserId
      ? impersonatedUser
      : (recentUsers.find((user) => user.id === authAsUserId) ?? null);

  return (
    auth?.client?.name || storedUser?.client?.name || auth?.user?.email || storedUser?.email || null
  );
}
